"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('widgets/shared/identity/changePassword/changePassword',["require", "exports", "text!./changePassword.html", "knockout", "models/userIdentityModel", "services/authenticationService"], function (require, exports, templateMarkup, ko, userIdentityModel, authenticationService) {
    "use strict";
    /// <amd-dependency path='text!./changePassword.html' name='templateMarkup' />

    var ChangePassword = function () {
        function ChangePassword() {
            _classCallCheck(this, ChangePassword);

            this.changingPassword = ko.observable(false);
            this.message = ko.observable('');
            this.messageVisible = ko.observable(false);
            this.oldPassword = ko.observable('');
            this.newPassword = ko.observable('');
            this.confirmPassword = ko.observable('');
            this.isTileVisible = ko.observable(false);
            this.oldPasswordMissing = ko.observable(false);
            this.newPasswordMissing = ko.observable(false);
            this.confirmPasswordMissing = ko.observable(false);
            this.handleClaims();
            this.oldPassword.subscribe(this.oldPasswordMissing.bind(this, false));
            this.newPassword.subscribe(this.newPasswordMissing.bind(this, false));
            this.confirmPassword.subscribe(this.confirmPasswordMissing.bind(this, false));
        }

        _createClass(ChangePassword, [{
            key: "handleClaims",
            value: function handleClaims() {
                if (userIdentityModel.hasClaim('my-account', 'reset-password')) {
                    this.isTileVisible(true);
                }
            }
        }, {
            key: "changePassword",
            value: function changePassword() {
                var _this = this;

                this.message('');
                if (this.oldPassword() && this.newPassword() && this.confirmPassword()) {
                    this.changingPassword(true);
                    authenticationService.changePassword(this.oldPassword(), this.newPassword(), this.confirmPassword()).fail(function (data) {
                        if (data && data.responseJSON) {
                            var errors = [];
                            for (var key in data.responseJSON) {
                                errors.push(data.responseJSON[key]);
                            }
                            _this.showErrorMessage(errors[0]);
                        } else {
                            _this.showErrorMessage('Password change failed');
                        }
                    }).done(function (data) {
                        _this.reset();
                    }).always(function () {
                        return _this.changingPassword(false);
                    });
                } else {
                    this.oldPasswordMissing(this.oldPassword() === '');
                    this.newPasswordMissing(this.newPassword() === '');
                    this.confirmPasswordMissing(this.confirmPassword() === '');
                    this.showErrorMessage('Password change failed');
                }
            }
        }, {
            key: "showErrorMessage",
            value: function showErrorMessage(error) {
                this.message(error);
                this.messageVisible(true);
                setTimeout(this.messageVisible.bind(this, false), 3000);
                setTimeout(this.message.bind(this, ''), 3500);
            }
        }, {
            key: "reset",
            value: function reset() {
                this.oldPassword(null);
                this.newPassword(null);
                this.confirmPassword(null);
                this.changingPassword(false);
                this.message('');
            }
        }]);

        return ChangePassword;
    }();

    return { viewModel: ChangePassword, template: templateMarkup };
});
//# sourceMappingURL=changePassword.js.map;
